import { UntypedFormControl, Validators } from '@angular/forms';
import { allowLettersDigitsPunctuationSpacesEqualRegExp } from '@shared/const/regexp.const';
import { RegexValidator } from '@ui-kit/validation/utility/regExp';

export class DefaultTaskItemModel {
  id: number;
  name: UntypedFormControl;
  editMode = false;
  active = false;
  createMode = false;
  'can-select' = true;
  response: any;
  oldData: DefaultTaskResponseModel;

  constructor(data) {
    this.id = data.id;
    this.name = new UntypedFormControl(data.name, [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(100),
      RegexValidator(
        allowLettersDigitsPunctuationSpacesEqualRegExp,
        'Correct format: letters, numbers, -, /, space, punctuation, and equals sign'
      )
    ]);
    this.response = data;
    this.oldData = new DefaultTaskResponseModel(data);

    if (data.editMode) {
      this.editMode = data.editMode;
      this.active = this.editMode;
    }
    if (data.createMode) {
      this.createMode = data.createMode;
    }
  }
}

export class DefaultTaskSaveModel {
  name: string;

  constructor(data) {
    this.name = data.name.value;
  }
}

export class DefaultTaskResponseModel {
  name: string;

  constructor(data) {
    this.name = data.name;
  }
}
